export default __webpack_public_path__ + "static/media/Page3_BG.e79d552e.png";